import { render } from "./VatamanyukPartners.vue?vue&type=template&id=580b9069&scoped=true"
import script from "./VatamanyukPartners.vue?vue&type=script&lang=js"
export * from "./VatamanyukPartners.vue?vue&type=script&lang=js"

import "./VatamanyukPartners.vue?vue&type=style&index=0&id=580b9069&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580b9069"]])

export default __exports__